module.exports = __webpack_public_path__ + "img/10.c2bde771.svg";